import { InfoTooltip } from "@/components/shared/info-tooltip";
import { DESO_APP_NAME } from "@/utils/constants";

const DesoFeeTooltip = ({ iconSize }: { iconSize?: number }) => (
  <InfoTooltip
    iconSize={iconSize}
    text={
      <>
        All trades are executed by the {DESO_APP_NAME} DEX, which runs on the{" "}
        {DESO_APP_NAME} blockchain. This means we need to include a small{" "}
        network fee to process the transaction, just like we would on a{" "}
        blockchain like Ethereum or Bitcoin. Learn more about {DESO_APP_NAME}{" "}
        and why it's more efficient than other blockchains{" "}
        <a
          className="cursor-pointer underline underline-offset-2"
          target="_blank"
          href="https://deso.com"
        >
          here
        </a>
        .
      </>
    }
  />
);

export default DesoFeeTooltip;
